import { get, merge } from "lodash";
import * as Base from "./social.account";

const getPicture = (screenName, size) =>
  "https://twitter.com/" + screenName + "/profile_image?size=" + size;

const removeFirstCharacter = (string, character) =>
  string.substr(0, 1) === character ? string.replace(character, "") : string;

const addFirstCharacter = (string, character) =>
  string.substr(0, 1) === character ? string.substr(1) : character + string;

export function getAccount(account) {
  const screenName = removeFirstCharacter(get(account, "screenName", ""), "@");
  return merge(Base.getAccount(account, "twitter"), {
    followers: get(account, "followers", 0),
    url: "https://twitter.com/" + screenName,
    screenName: addFirstCharacter(screenName, "@"),
    bigPicture: getPicture(screenName, "original"),
    smallPicture: getPicture(screenName, "normal"),
    picture: getPicture(screenName, "bigger"),
    description: get(account, "description", ""),
    gender: get(account, "gender", null),
    "followers-count": get(account, "followers-count", 0),
    "followings-count": get(account, "followings-count", 0),
    "favourites-count": get(account, "favourites-count", 0),
    "statuses-count": get(account, "statuses-count", 0),
  });
}
